// Client-side "already seen" tracking for feature explainers
// Raw localStorage, keyed by user id, so the flag is PER USER and survives hard
// refresh, browser close, and logout:
//   - same user logs back in  -> already seen, not shown again
//   - a different user logs in -> not seen for them, shown
// Shape: { [userId]: { [feature]: true } }
const STORAGE_KEY = "explainer-seen";

function getAll() {
  try {
    return JSON.parse(window.localStorage.getItem(STORAGE_KEY)) || {};
  } catch (e) {
    return {};
  }
}

export function hasSeenExplainer(userId, feature) {
  if (!userId) return false;
  const all = getAll();
  return !!(all[userId] && all[userId][feature]);
}

export function markExplainerSeen(userId, feature) {
  if (!userId) return;
  try {
    const all = getAll();
    all[userId] = all[userId] || {};
    all[userId][feature] = true;
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
  } catch (e) {
    // localStorage unavailable (private mode/quota) — fail open, just skip.
  }
}
